/* ============================================================================
   mm_cart.js — LE fichier du panier (drawer latéral Moon Moon)
   ----------------------------------------------------------------------------
   Chargé globalement par layout/theme.liquid. Pilote la section
   sections/mm-cart.liquid (tiroir panier) : ouverture/fermeture, ajout
   produit + upsells/accessoires, quantités, code promo, frais de port par
   pays, barres de progression (paliers cadeaux/remises).

   Principe central : chaque mutation du panier passe par mmAPIRequest() qui
   appelle l'API AJAX Shopify (cart/add.js, cart/change.js, cart/update.js)
   avec `sections: "mm-cart"` (Section Rendering API). Le HTML re-rendu de la
   section est renvoyé dans data.sections["mm-cart"] et réinjecté dans le DOM
   par refreshCartFromData().

   Fonctions exposées en global et appelées depuis le Liquid :
   - mmOpenCart / mmCloseCart        → sections/header.liquid, mm-cart.liquid,
                                       sections cg-* (sticky cart, specs, hero)
   - mmAddProductToCart              → main-product.liquid, MM-Modal-Tailles,
                                       MM-Text-Image-Video, MM-Video-Onglets,
                                       snippets/mm-product-card, sections cg-*
   - mmIncrease/Decrease/DestroyProductQuantity → snippets/mm-cart-item.liquid
   - mmAddCrossSellToCart, mmOpen/CloseVariantPopUp
                                     → snippets/mm-cart-cross-sell-*.liquid
   - mmToggleDiscountCode / mmApplyDiscountCode / mmRemoveDiscountCode
                                     → sections/mm-cart.liquid (footer drawer)
   - updatePricesBasedOnCart, refreshCartFromData, updateCartCount
                                     → réutilisées par les sections cg-*

   Dépendances définies AILLEURS (inline dans sections/mm-cart.liquid) :
   listDeliveryTaxes (tableau des tarifs livraison), updatePays(), mmTextFree().
   Dépendance externe : librairie Splide (sliders).
   ========================================================================== */

// Splide init
// Initialise les 2 sliders du drawer : cross-sell (.splide-mm-cart — la
// classe vient de "splide-{{ section.id }}" dans mm-cart.liquid, où
// section.id vaut "mm-cart" : c'est BIEN le carrousel du tiroir) et
// réassurance (.splide-dc-reassurance). Appelée au DOMContentLoaded et
// re-appelée par refreshCartFromData() car l'innerHTML réinjecté détruit
// les instances Splide précédentes.
function mmInitSplide() {
    const splideElem = document.querySelector('.splide-mm-cart');

    if (splideElem) {
        new Splide(splideElem, {
			type: "slide",
			arrows: true,
			pagination: true,
      gap: 8,
      wheel: true,
      padding: {
        left: '16px',
        right: '60px',
      },
			breakpoints: {
				768: {
					// 11/08/2026 (demande Christopher) : flèches réactivées sur mobile
					// (elles étaient coupées depuis le 29/06 « mobile = swipe »). Splide
					// doit les RENDRE ici ; leur placement (sous la carte, avec les
					// points) vit dans mm-cart.css, et le mode non repliable les
					// re-masque en CSS pour conserver l'historique swipe seul.
					arrows: true,
					pagination: true,
					padding: {
						right: '1rem',
						left: "1rem",
					},
					gap: 10,
				},
			},
		}).mount();
    }
    
    var splideElemRea = document.querySelector('.splide-dc-reassurance');

    if (splideElemRea) {
      new Splide(splideElemRea, {
        type: 'splide',
        arrows: false,
        pagination: true,
        gap: 0,
        perPage: 1,
        autoplay: true,
        // BUG (typo) : "inetrval" au lieu de "interval" — Splide ignore
        // l'option et autoplay tourne sur son défaut (5000 ms).
        inetrval: 3000,
        rewind: true
      }).mount();
    }
}

// Slider vertical auto-défilant des délais de livraison, visible uniquement
// en mobile (détruit ≥768px via breakpoints.destroy). Markup dans
// sections/mm-cart.liquid (.mm-slider-delivery-mobile). Ré-initialisé par
// refreshCartFromData() après chaque re-render du drawer.
function mmInitSlider_mobile_delivery() {
    const id = ".mm-slider-delivery-mobile";
    const splideElem = document.querySelector(id);

    if (splideElem) {
        new Splide(splideElem, {
            type: "loop",
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 2000,
            height: 30,
            perPage: 1,
            direction: "ttb",
            mediaQuery: "min",
            breakpoints: {
                768: {
                    destroy: true,
                },
            },
        }).mount();
    }
}
document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplide();
        mmInitSlider_mobile_delivery();
        mmGetDeliveryTaxes();
        mmCartPageLayout();
    },
    { once: true }
);

// 01/09/2026 — MODE PAGE, mise en page ordinateur (A/B test « tiroir vs page
// panier »). Sur /cart en mode page et à partir de 990px, les blocs du récap
// (frise, frais de port, code promo + CTA, réassurance, mention légale) sont
// regroupés dans un conteneur .mm-cart-page-recap placé en colonne de droite
// par la grille CSS (mm-cart.css, bloc MODE PAGE) ; les lignes produit et le
// cross-sell restent à gauche, sans trou entre eux. Sous 990px (ou hors mode
// page) les blocs reprennent leur place d'origine = l'ordre du tiroir mobile.
// Idempotent : rappelée après chaque re-rendu (refreshCartFromData remplace
// l'intérieur du voile) et au redimensionnement.
// État ouvert/replié du cross-sell sur la page : null = jamais rendu (→ ouvert
// par défaut en mode page, demande Christopher 01/09), sinon le dernier état
// vu avant un re-rendu, pour respecter le choix du client.
var mmCsEtatPage = null;

function mmCartPageLayout() {
    var voile = document.querySelector(".mm-drawer-cart-filter.mm-cart-page");
    if (!voile) return;
    var panneau = voile.querySelector(".mm-drawer-cart");
    if (!panneau) return;
    var recap = panneau.querySelector(".mm-cart-page-recap");
    var produits = panneau.querySelector(".mm-dc-products-container");
    var crossSell = panneau.querySelector(".mm-dc-cross-sell");
    var bloc = function (sel) { return panneau.querySelector(sel); };
    var vide = !panneau.querySelector("[data-cart-item-key]");
    // Mode page effectif = réglage « page », à toutes les largeurs depuis le
    // 14/09/2026 (auparavant ordinateur seulement). Sous 990px : une colonne
    // dans l'ordre du tiroir (mobile compris) ; à partir de 990px : récap à droite.
    var modePage = mmCartPageMode();

    // Panier vide : une seule colonne (cartes de collections + CTA dessous),
    // pas de récap flottant. La classe pilote la grille dans mm-cart.css.
    panneau.classList.toggle("mm-cart-page-empty", vide);

    // Cross-sell déplié par défaut sur la page, mobile compris (le tiroir, lui,
    // suit son réglage) ; après un re-rendu on restaure l'état précédent.
    if (modePage && crossSell && !crossSell.dataset.mmCsInit) {
        crossSell.dataset.mmCsInit = "1";
        crossSell.classList.toggle("mm-cs-open", mmCsEtatPage === null ? true : mmCsEtatPage);
    }

    if (modePage && window.innerWidth >= 990 && !vide) {
        if (recap || !produits) return;
        recap = document.createElement("div");
        recap.className = "mm-cart-page-recap";
        [".mm-cart-progress-bar-container", ".mm-dc-delivery-taxes-container", ".mm-dc-bottom", ".mm-dc-reassurance", ".mm-dc-bottom-text"]
            .forEach(function (sel) { var el = bloc(sel); if (el && el.parentElement === panneau) recap.appendChild(el); });
        produits.insertAdjacentElement("afterend", recap);
    } else if (recap) {
        // Retour à l'ordre du tiroir : frise avant les lignes, frais de port
        // après les lignes, code promo/CTA + réassurance + mention après le cross-sell.
        var frise = recap.querySelector(".mm-cart-progress-bar-container");
        var livraison = recap.querySelector(".mm-dc-delivery-taxes-container");
        if (frise && produits) produits.insertAdjacentElement("beforebegin", frise);
        if (livraison && produits) produits.insertAdjacentElement("afterend", livraison);
        var ancre = crossSell || livraison || produits;
        [".mm-dc-bottom", ".mm-dc-reassurance", ".mm-dc-bottom-text"].forEach(function (sel) {
            var el = recap.querySelector(sel);
            if (el && ancre) { ancre.insertAdjacentElement("afterend", el); ancre = el; }
        });
        recap.remove();
    }
}
window.addEventListener("resize", debounce(mmCartPageLayout, 200));

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

// ===== Petits accesseurs DOM du drawer panier =====
// Tous relatifs à la section #shopify-section-mm-cart (sections/mm-cart.liquid).
// Une ligne panier est identifiée par data-cart-item-key={{ item.key }}
// (snippets/mm-cart-item.liquid) ; sa quantité affichée vit dans
// [data-item-quantity] (source de vérité optimiste côté client, voir
// mmIncrease/DecreaseProductQuantity).
function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(lineItemKey) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-key="${lineItemKey}"]`);
}

function mmCartItemQuantityEl(lineItemKey) {
    const itemEl = mmCartItem(lineItemKey);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(lineItemKey) {
    const quantityEl = mmCartItemQuantityEl(lineItemKey);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(lineItemKey, newQuantity) {
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(lineItemKey);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

// Parse le HTML re-rendu de la section mm-cart (Section Rendering API)
// dans un <div> détaché, pour pouvoir y faire des querySelector.
function mmCartHTMLFromData(data) {
    const el = document.createElement("DIV");
    // console.log('data.sections["mm-cart"] :', data.sections["mm-cart"]);
    el.innerHTML = data.sections["mm-cart"];
    return el;
}

// NOTE : les 4 fonctions suivantes (extractItemsFromCartHTML,
// insertCartProductsFromResponse, extractTotalPriceFromCartHTML,
// insertInsertTotalPriceFromResponse) ne sont appelées nulle part dans le
// thème — ancien mécanisme de mise à jour partielle, remplacé par
// refreshCartFromData() qui remplace tout l'intérieur du drawer. Code mort.
function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

    return data;
}

function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
    return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

    return data;
}

// Cœur réseau du panier : fetch vers l'API AJAX Shopify (path relatif à la
// racine localisée, ex "cart/add.js"). Utilisée par toutes les mutations
// (add/change/update) et par mmGetCart.
// Effets de bord, en plus du fetch :
// - grise le drawer (.mm-inactive) pendant la requête ;
// - met à jour la barre de progression "palier atteint" du drawer
//   (#mmCartProgressBarValue = montant du palier injecté par mm-cart.liquid ;
//   le cookie "discount_code" posé par une LP peut forcer la barre à 100%) ;
// - stocke total_price/total_weight sur le CTA (.mm-dc-cta), lus ensuite
//   par mmGetDeliveryTaxes() et updateProgressBarFull() ;
// - rafraîchit la bulle compteur du header (updateCartCount).
// NB : le rejet sur data.status > 400 arrive APRÈS ces mises à jour UI.
function mmAPIRequest(method, path, body) {
    // 26.10.2026 (lot B S44, erreurs JS navigateurs intégrés Meta) : gardes
    // ?. / if sur les éléments du drawer — un élément absent ne doit plus
    // interrompre l'ajout au panier.
    document.querySelector(".mm-dc-products")?.classList.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            if (document.querySelector(".mm-dc-products")) {
                document.querySelector(".mm-dc-products").classList.remove("mm-inactive");
            }
            if (mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner")) { 

              // Afficher le cookie "discount_code"
              const discountCodeCookie = getCookie("discount_code");
              let freeShippingDiscount = false;

              if (discountCodeCookie) {
                const discountCode = document.querySelector("#mmCartProgressBarValue")?.dataset.discountCode;
                if (discountCode && discountCodeCookie == discountCode ) {
                  freeShippingDiscount = true
                  console.log("Cookie 'discount_code' trouvé :", discountCode);
                }
              }

                const cartProgressId = document.querySelector('#mmCartProgressBarValue');
                const cartProgressValue = cartProgressId.value;
                const freeItemsProgress = mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner");
                // Division par 2 : le seuil correspond visuellement à la
                // moitié de la barre (le palier est dessiné au milieu).
                // items_subtotal_price = sous-total après remises de LIGNE
                // (-50%) mais avant remises de COMMANDE (5€) : même base que
                // les minimums d'achat Shopify (cf. mm-cart.liquid, 29/07/2026)
                // — le 5€ gagné ne rabaisse toujours pas la barre sous son palier.
                const newWidth = ((data.items_subtotal_price / cartProgressValue) * 100) / 2;

              console.log(freeShippingDiscount)

                // 10/08/2026 : quand le palier de remise porte une phrase au lieu
                // d'un montant et qu'aucun produit déclencheur n'est au panier,
                // aucun montant ne l'ouvrira — la barre ne doit donc pas
                // progresser jusqu'à sa pastille. Le rendu serveur applique déjà
                // ce plafond (cf. mm-cart.liquid) ; on le reproduit ici, sinon la
                // barre repasserait devant dès la première modification du panier.
                const capFirstStep = cartProgressId.dataset.capFirstStep === 'true';

                if (!freeShippingDiscount && capFirstStep) {
                    freeItemsProgress.style.width = `${Math.min(newWidth, 15)}%`;
                } else if (freeShippingDiscount || newWidth >= 50) {
                    freeItemsProgress.style.width = "100%";
                  console.log('100%')
                } else {
                    freeItemsProgress.style.width = `${newWidth}%`;
                  console.log(newWidth)
                }

                if ( freeShippingDiscount || data.items_subtotal_price >= cartProgressValue ) {
                    document.querySelector(".mm-dc-free-item-progress-wrapper")?.classList.add("mm-dc-pb-success");
                } else {
                    document.querySelector(".mm-dc-free-item-progress-wrapper")?.classList.remove("mm-dc-pb-success");
                }
            }
            var cta = document.querySelector(".mm-dc-cta");
            if (cta) {
            cta.dataset.totalPrice = data.total_price;
            // progressPrice = sous-total après remises de ligne, avant remises
            // de commande (items_subtotal_price, cf. mm-cart.liquid 29/07/2026) :
            // alimente les frises (drawer + fiche produit). Distinct de
            // totalPrice (= total payé, réservé aux frais de port
            // mmGetDeliveryTaxes).
            cta.dataset.progressPrice = data.items_subtotal_price;
            cta.dataset.totalWeight = data.total_weight;
            }
            mmGetDeliveryTaxes();
            updateCartCount(data.item_count != null ? data.item_count : 0);
            return data;
        })
        .then((data) => {
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

// récupérer le panier
// Jamais appelée dans le thème : utilitaire de debug console uniquement.
function mmGetCart() {
    mmAPIRequest("GET", "cart.js").then(console.log);
}

// 01/09/2026 — MODE PAGE (A/B test « tiroir vs page panier »). Le réglage
// thème cart_mode est exposé par data-cart-mode sur le voile du tiroir
// (sections/mm-cart.liquid). D'abord réservé à l'ordinateur (≥ 769px), il
// est étendu au MOBILE le 14/09/2026 (demande Christopher : « adapte le design
// du desktop sur mobile ») : le mode page vaut désormais à toutes les largeurs.
// En mode page : « ouvrir le panier » = aller sur la page /cart (racine
// localisée, comme mmAPIRequest), sauf si on y est déjà (le voile porte alors
// .mm-cart-page) ; « fermer » = rien à faire. Tous les appelants (icône du
// header, mmAddProductToCart après ajout, sections cg-*) passent par ces deux
// fonctions : aucun autre fichier n'a à changer.
function mmCartPageMode() {
    var voile = document.querySelector(".mm-drawer-cart-filter");
    return !!(voile && voile.dataset.cartMode === "page");
}

// Ouvrir le panier
// Appelée par l'icône panier du header (sections/header.liquid, onclick),
// par mmAddProductToCart après un ajout, et par les sections cg-* en
// fallback (window.mmOpenCart). stop-scrolling fige le body derrière.
function mmOpenCart() {
    if (mmCartPageMode()) {
        if (!document.querySelector(".mm-drawer-cart-filter")?.classList.contains("mm-cart-page")) {
            window.location.href = window.Shopify.routes.root + "cart";
        }
        return;
    }
    // 26.10.2026 (lot B S44) : sans drawer sur la page, on ne fige pas le défilement
    var mmFiltre = document.querySelector(".mm-drawer-cart-filter");
    if (!mmFiltre) return;
    mmFiltre.classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer le panier
// Appelée par la croix et l'overlay du drawer (sections/mm-cart.liquid).
function mmCloseCart() {
    if (mmCartPageMode()) return;
    document.querySelector(".mm-drawer-cart-filter")?.classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
// Point d'entrée unique du re-render : remplace tout l'intérieur du drawer
// par le HTML de data.sections["mm-cart"], puis ré-initialise tout ce qui
// est perdu avec l'innerHTML (sliders Splide, compteur, frais de port,
// barres de progression, prix accessoires). Chaînée en .then() après chaque
// mutation (add/change/update). Aussi appelée par les sections cg-*.
function refreshCartFromData(data) {
    // Mode page : mémorise l'état du cross-sell avant que l'innerHTML soit remplacé.
    var csAvant = mmCartSectionElement().querySelector(".mm-cart-page .mm-dc-cross-sell");
    if (csAvant) { mmCsEtatPage = csAvant.classList.contains("mm-cs-open"); }
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
    const newInnerCart = newCartEl.querySelector(".mm-drawer-cart-filter");
    // 26.10.2026 (lot B S44) : réponse sans HTML de section (ou drawer absent)
    // → on ne remplace rien plutôt que de planter au milieu du re-render.
    if (!innerCart || !newInnerCart) return;
    innerCart.innerHTML = newInnerCart.innerHTML;
    const productProgressBarContainer =  document.querySelector('.mm-product-progress-bar-container .mm-dc-free-item-progress-wrapper');
    if (productProgressBarContainer) {
      //productProgressBarContainer.innerHTML = newCartEl.querySelector(".mm-product-progress-bar-container .mm-dc-free-item-progress-wrapper").innerHTML;
    }
    mmInitSplide();
    mmInitSlider_mobile_delivery();
    const newCount = newCartEl.querySelector("[data-cart-count]");
    if (newCount) updateCartCount(newCount.dataset.cartCount);
    mmGetDeliveryTaxes();
    discountFreeShipping();
    updateProgressBarFull();
    //updateProgressBarPreview();
    updatePricesBasedOnCart();
    mmCartPageLayout(); // mode page : regroupe le récap en colonne de droite (ordinateur)
}

// ============ Discount code (cart drawer footer) ============

// Toggle open/close du bloc Code promotionnel. Auto-focus l'input à l'ouverture
// pour faire pop le clavier mobile.
function mmToggleDiscountCode(headerEl) {
    const wrapper = headerEl.closest('.mm-dc-discount-code');
    if (!wrapper) return;
    // Si un code est déjà appliqué, le header n'expose pas de form : pas de toggle.
    if (wrapper.classList.contains('mm-applied')) return;

    const isOpen = wrapper.classList.toggle('mm-open');
    if (isOpen) {
        const input = wrapper.querySelector('input[name="discount"]');
        if (input) {
            // setTimeout pour laisser le navigateur réflowing avant le focus,
            // sinon iOS ne fait pas pop le clavier dans certaines conditions.
            setTimeout(() => input.focus(), 50);
        }
    }
}

// Soumission du form code promo : POST /cart/update.js avec discount.
function mmApplyDiscountCode(formEl) {
    const input = formEl.querySelector('input[name="discount"]');
    const submitBtn = formEl.querySelector('button[type="submit"]');
    const errorEl = formEl.querySelector('.mm-dc-discount-code-error');
    const code = (input.value || '').trim();
    if (!code) return;

    if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
    }
    if (submitBtn) submitBtn.disabled = true;

    mmAPIRequest('POST', 'cart/update.js', {
        discount: code,
        sections: 'mm-cart',
    })
    .then((data) => {
        if (submitBtn) submitBtn.disabled = false;
        // Shopify renvoie 200 même pour un code invalide : on vérifie applicable.
        const dc = (data.discount_codes || []).find(d =>
            (d.code || '').toUpperCase() === code.toUpperCase()
        );
        if (!dc || !dc.applicable) {
            if (errorEl) {
                errorEl.textContent = formEl.dataset.errorInvalid || 'Code invalide ou non applicable.';
                errorEl.hidden = false;
            }
            return;
        }
        refreshCartFromData(data);
    })
    .catch(() => {
        if (submitBtn) submitBtn.disabled = false;
        if (errorEl) {
            errorEl.textContent = formEl.dataset.errorGeneric || 'Une erreur est survenue, réessayez.';
            errorEl.hidden = false;
        }
    });
}

// Retire le code appliqué : POST /cart/update.js avec discount vide.
// Le bouton X est passé en argument pour griser le badge pendant l'appel.
function mmRemoveDiscountCode(btnEl) {
    const badge = btnEl ? btnEl.closest('.mm-dc-discount-code-badge') : null;
    if (badge) badge.classList.add('mm-loading');

    mmAPIRequest('POST', 'cart/update.js', {
        discount: '',
        sections: 'mm-cart',
    })
    .then(refreshCartFromData)
    .catch(() => {
        // En cas d'erreur le DOM n'est pas remplacé, donc on retire la classe
        // pour redonner la main au client. Sur succès, refreshCartFromData
        // remplace l'innerHTML du drawer et la classe disparaît avec lui.
        if (badge) badge.classList.remove('mm-loading');
    });
}

// Ajouter un item au panier
// LA fonction d'ajout panier du thème, appelée en onclick depuis :
// main-product.liquid, MM-Modal-Tailles, MM-Text-Image-Video,
// MM-Video-Onglets, snippets/mm-product-card, et via window.mmAddProductToCart
// par les sections cg-* (sticky-cart, specs, hero-banner, multiproduits).
// productId = ID de VARIANTE. En plus du produit demandé, elle embarque
// silencieusement : l'upsell plaque métal si sa carte est active sur la page
// (.mm-upsell-plaque-metal sans .mm-clickable) et les accessoires cochés
// (.mm-product-accessories-container). POST cart/add.js puis re-render drawer.
// ATTENTION : le 3e paramètre `checkout` n'est jamais lu dans le corps —
// MM-Modal-Tailles.liquid passe `true` en croyant déclencher un checkout, sans
// effet. Certaines sections cg-* passent aussi `1` en 2e argument au lieu d'un
// objet : la déstructuration retombe alors sur les défauts (quantity=1,
// openCart=true), ce qui marche par chance.
function mmAddProductToCart(productId, { quantity = 1, openCart = true }, checkout = false) {
  console.log('product id', productId);
  let items = [];

  // Gestion du upsell plaque métal
  const plaqueMetalUpsell = document.querySelector(".mm-upsell-plaque-metal");
  if (plaqueMetalUpsell && !plaqueMetalUpsell.classList.contains('mm-clickable')) {
    const upsellId = plaqueMetalUpsell.dataset.plaqueId;
    items.push({
      quantity: 1,
      id: upsellId,
    });
  }

  // Ajout du produit principal
  items.push({
    quantity: quantity,
    id: productId,
  });

  // Ajout des accessoires cochés
  const accessoryCheckboxes = document.querySelectorAll(".mm-product-accessories-container input[type='checkbox']:checked");
  accessoryCheckboxes.forEach((checkbox) => {
    items.push({
      quantity: 1,
      id: checkbox.value,
    });
  });

  // Envoi vers le panier
  mmAPIRequest("POST", "cart/add.js", {
    items: items,
    sections: "mm-cart",
  })
    .then(refreshCartFromData)
    .then((data) => {
      if (openCart) {
        setTimeout(mmOpenCart);
      }
      // Reset du product form button
      const ctaElements = document.querySelectorAll('#product-form .mm-product-cta .mm-product-price-update');
      if (!ctaElements || ctaElements.length === 0) {
        return;
      }      
      ctaElements.forEach(cta => {
        const initialPrice = cta.dataset.price;
        if (!initialPrice || isNaN(initialPrice)) {
          return;
        }
        cta.dataset.value = initialPrice;
        cta.innerHTML = `${(initialPrice / 100).toFixed(2).replace('.', ',')}€`;
      });      
    })
    .catch((error) => {
      mmOpenCart();
      console.log(error);
    });

}

// Ajout d'un cross-sell depuis la popup variantes du drawer
// (snippets/mm-cart-cross-sell-select-variants.liquid, onclick).
function mmAddCrossSellToCart(btnElem) {
  let card = btnElem.closest('.mm-dc-product-variant-popup');
  const select = card.querySelector('select.mm-upsell-variant-values');
  const variantId = parseInt(select.value);
  mmAddProductToCart(variantId, { quantity: 1, openCart: false });
}

// Variante mobile (carte .mm-dc-cs-product) — aucun appelant trouvé dans
// sections/ ni snippets/ : code mort probable.
function mmAddCrossSellToCartMobile(btnElem) {
  let card = btnElem.closest('.mm-dc-cs-product');
  const select = card.querySelector('select.mm-upsell-variant-values');
  const variantId = parseInt(select.value);
  mmAddProductToCart(variantId, { quantity: 1, openCart: false });
}

// ===== Quantités (boutons +/−/poubelle de snippets/mm-cart-item.liquid) =====
// Stratégie optimiste : le chiffre affiché est mis à jour immédiatement dans
// le DOM, puis la vraie requête cart/change.js est débouncée (300 ms) pour
// absorber les clics rapides. Quantité 0 = suppression de la ligne.
function mmIncreaseProductQuantity(lineItemKey) {
    const quantity = mmGetCartItemQuantity(lineItemKey);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(lineItemKey, newQuantity);

    mmDebouncedPushNewQuantity(lineItemKey);
}

function mmDecreaseProductQuantity(lineItemKey) {
    const quantity = mmGetCartItemQuantity(lineItemKey);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(lineItemKey, newQuantity);

    mmDebouncedPushNewQuantity(lineItemKey);
}

function mmDestroyProductFromCart(lineItemKey) {
    const newQuantity = 0;
    mmSetCartItemQuantity(lineItemKey, newQuantity);

    mmDebouncedPushNewQuantity(lineItemKey);
}

// Envoie au serveur la quantité actuellement affichée dans le DOM
// (cart/change.js) puis re-rend le drawer. Toujours passer par la version
// débouncée mmDebouncedPushNewQuantity ci-dessous.
function mmPushNewQuantity(lineItemKey) {
    const quantity = mmGetCartItemQuantity(lineItemKey);

    mmAPIRequest("POST", "cart/change.js", {
        id: lineItemKey,
        quantity: quantity,
        sections: "mm-cart",
    })
    .then(refreshCartFromData)
}

const mmDebouncedPushNewQuantity = debounce(function (lineItemKey) {
    mmPushNewQuantity(lineItemKey);
}, 300);

// CROSS SELL
// Ouvre/ferme la popup de choix de variante d'une carte cross-sell
// (snippets/mm-cart-cross-sell-item.liquid, onclick). Le setTimeout de 300 ms
// à la fermeture laisse finir la transition CSS avant de repousser la popup.
function mmOpenVariantPopUp(elem) {
    var variantPopUp = elem.querySelector(".mm-dc-product-variant-popup");
    variantPopUp.style.top = "0";
}
function mmCloseVariantPopUp(elemClass) {
    var elem = document.querySelector(elemClass);
    if (!elem) return; // 26.10.2026 (lot B S44)
    setTimeout(() => {
        elem.style.top = "100%";
    }, "300");
}


// Estimation des frais et délais de livraison affichés dans le drawer.
// Activée seulement si la section a data-delivery-taxes="true".
// Pays détecté en cascade : sessionStorage.ipCountryCode (posé par
// mm-flag-and-ip.js) → langue Weglot → attribut lang du <html>.
// Région tarifaire : FR_BE / UE (timezone Europe) / World, croisée avec le
// poids et le total du panier pour fabriquer une clé (ex "UE_standart_under_49")
// cherchée dans listDeliveryTaxes — tableau injecté inline par
// sections/mm-cart.liquid depuis les metaobjects. updatePays() et mmTextFree()
// sont aussi définies dans ce même fichier Liquid.
// Appelée au DOMContentLoaded, après chaque mmAPIRequest et chaque re-render.
// NB : seuils 4900/9900 (49€/99€) et poids 100 g codés en dur.
function mmGetDeliveryTaxes() {
    if (document.querySelector(".mm-drawer-cart-filter")?.dataset.deliveryTaxes == "true") {
        var codePays;
        if (sessionStorage["ipCountryCode"] != null && sessionStorage["ipCountryCode"] != "null" && sessionStorage["ipCountryCode"] != "undefined") {
            codePays = sessionStorage["ipCountryCode"];
        } else if (document.querySelector(".weglot-container .wgcurrent") != null) {
            codePays = document.querySelector(".weglot-container .wgcurrent").dataset.l.toUpperCase();
        } else {
            codePays = document.documentElement.lang.toUpperCase();
        }

        var timeZone = sessionStorage["timezone"];
        if (timeZone == null) {
            timeZone = "EU";
        }
        var cta = document.querySelector(".mm-dc-cta");
        if (!cta) return; // 26.10.2026 (lot B S44)
        var total_price = cta.dataset.totalPrice;
        var total_weight = cta.dataset.totalWeight;

        var region;
        var weight;
        var key;
        var price;

        // Update le titre de la section
        updatePays(codePays);

        // code pays
        if (codePays == "FR" || codePays == "BE") {
            region = "FR_BE";
        } else if (timeZone.includes("Europe")) {
            region = "UE";
        } else {
            region = "World";
        }

        // Poids
        var cart_emtpy = false;
        if (total_price == 0) {
            cart_emtpy = true;
        } else if (total_weight < 100) {
            weight = "_100";
            key = region + weight;
        } else {
            weight = "_standart";
            if (total_price < 4900) {
                price = "_under_49";
            } else if (region != "World") {
                price = "_more_than_49";
            } else if (total_price < 9900) {
                price = "_between_49_99";
            } else if (total_price >= 9900) {
                price = "_more_than_99";
            }
            key = region + weight + price;
        }
        //console.log(key);
        var item = null;
        item = listDeliveryTaxes.find((item) => {
            if (item.key === key) {
                return item;
            }
        });

        var delivery_container = document.querySelector(".mm-dc-delivery-taxes-container");
        var ul_delivery = document.querySelector(".mm-dc-delivery-taxes-content");
        if (!delivery_container || !ul_delivery) return; // 26.10.2026 (lot B S44)
        ul_delivery.innerHTML = "";
        var mobileContainer = document.querySelector("#mm-delivery-mobile-time");

        if (cart_emtpy) {
            delivery_container.style.display = "none";
        } else {
            delivery_container.style.display = "block";
        }
        if (item != null && item.type_denvoi_1 != null && item.type_denvoi_1 != "unset") {
            var li = newDeliveryLine(item.type_denvoi_1, item.prix_1, item.delais_1);
            ul_delivery.appendChild(li);
            if (mobileContainer != null) {
                mobileContainer.innerHTML = item.delais_1;
            }
        }
        if (item != null && item.type_denvoi_2 != null && item.type_denvoi_2 != "unset") {
            var li = newDeliveryLine(item.type_denvoi_2, item.prix_2, item.delais_2);
            ul_delivery.appendChild(li);
        }
        if (item != null && item.type_denvoi_3 != null && item.type_denvoi_3 != "unset") {
            var li = newDeliveryLine(item.type_denvoi_3, item.prix_3, item.delais_3);
            ul_delivery.appendChild(li);
        }
    }
}

// Fabrique un <li> "Mode d'envoi : délai — prix" pour la liste des frais de
// port du drawer. Prix "0.0" → libellé "Gratuit" traduit (mmTextFree, défini
// dans sections/mm-cart.liquid). Symbole € codé en dur.
function newDeliveryLine(name, price, time) {
    // Création des éléments DOM
    var li = document.createElement("li");
    var nameAndTimeSpan = document.createElement("span");
    var priceSpan = document.createElement("span");
    var div = document.createElement("div");

    // Définition des valeurs des éléments
    nameAndTimeSpan.innerHTML = name + " : " + time;
    if (price == "0.0") {
        priceSpan.innerHTML = mmTextFree();
    } else {
        priceSpan.innerHTML = price.replace(".", ",") + "€";
    }

    // Ajout des éléments au DOM
    div.appendChild(nameAndTimeSpan);
    div.appendChild(priceSpan);
    li.appendChild(div);

    // Retourne l'élément de ligne créé
    return li;
}

// Cart count
// Met à jour la bulle compteur de l'icône panier du header
// (sections/header.liquid, .mm-cart-count-bubble).
function updateCartCount(value) {
    var cartCountValue = document.querySelector(".mm-cart-count-bubble span");
    cartCountValue.innerText = value;
}

// check cookies
// Lit un cookie par son nom (null si absent). Utilisé pour "discount_code",
// posé en amont par les landing pages pour pré-appliquer une remise.
function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null; // Si le cookie n'est pas trouvé
}

// Si le cookie "discount_code" correspond au code "livraison offerte"
// configuré sur la barre (#mmCartProgressBarValue[data-discount-code]),
// force la barre de progression du drawer à 100% + état succès.
// Appelée immédiatement au chargement du script (ligne suivant la fonction)
// et après chaque re-render (refreshCartFromData).
// 26.10.2026 (lot B S44) : gardes posées. Avant, si le cookie existait (posé
// par Shopify sur un lien /discount/CODE, fréquent sur le trafic pub) mais que
// #mmCartProgressBarValue était absent, le querySelector(...).dataset levait
// une TypeError dès le chargement de mm_cart.js.
function discountFreeShipping() {
  let freeShippingDiscount = false;
  // Afficher le cookie "discount_code"
  const discountCodeCookie = getCookie("discount_code");
  if (discountCodeCookie) {
    const discountCode = document.querySelector("#mmCartProgressBarValue")?.dataset.discountCode;
    if (discountCode && discountCodeCookie == discountCode ) {
      freeShippingDiscount = true
      console.log("Cookie 'discount_code' trouvé :", discountCode);
      const freeItemsProgress = mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner");
      if (freeItemsProgress) freeItemsProgress.style.width = "100%";
      document.querySelector(".mm-dc-free-item-progress-wrapper")?.classList.add("mm-dc-pb-success", "mm-dc-pb-success-discount");
    }
  }

}

discountFreeShipping()

// Recharge via Section Rendering API le bloc accessoires de la fiche produit
// (.mm-product-accessories-container) pour refléter l'état du panier.
// Aucun appelant trouvé dans le thème : code mort probable.
function updateProductForm() {
  const containerSelector = '.mm-product-accessories-container';
  const container = document.querySelector(containerSelector);

  if (!container) return; // Ne fait rien si le conteneur n'existe pas

  const sectionId = container.closest('section').id.replace('shopify-section-', '');
  
  fetch(window.location.pathname + `?sections=${sectionId}`)
    .then((response) => response.json())
    .then((data) => {
      const parser = new DOMParser();
      const sectionHTML = data[sectionId];
      const doc = parser.parseFromString(sectionHTML, 'text/html');
      const newContent = doc.querySelector(containerSelector);

      if (newContent) {
        container.innerHTML = newContent.innerHTML;
      }
    })
    .catch((error) => {
      console.error('Erreur lors du rechargement de la section :', error);
    });
}

// Bascule prix réduit / prix original sur les cartes accessoires
// (.mm-accessory-card, snippets/mm-accessory-card.liquid) quand le total
// prédictif (panier + produit courant) atteint 30€ (3000 centimes, en dur).
// Appelée par refreshCartFromData et par les sections cg-* (window.*).
// ATTENTION : querySelector('data-accessory-in-cart') cible la BALISE
// <data-accessory-in-cart> sans vérifier value="true" (contrairement à
// updateProgressBarFull) — accessoryInCart est donc vrai dès que la balise
// existe, même avec value="false".
function updatePricesBasedOnCart() {
  // Fix (22/06) : cette fonction dupliquait — en pire — la logique de
  // updateCardPrices (mm-main-product-helper.js). Problèmes : AUCUN garde de
  // type (elle affichait le -50% sur TOUTES les cartes, lumières comprises),
  // un seuil 3000 incohérent (vs 2900 = palier 29€), et un test de marqueur
  // qui ne posait jamais l'état "accessoire au panier". Pire : refreshCartFromData
  // l'appelait APRÈS updateProgressBarFull → elle écrasait le rendu correct à
  // CHAQUE refresh du panier. On délègue donc à updateCardPrices = source unique
  // de vérité (garde type "Accessoires" + règle "accessoire déjà au panier =
  // créneau -50% consommé → toutes les cartes au plein tarif").
  if (typeof updateCardPrices === 'function') updateCardPrices();
}

document.addEventListener("DOMContentLoaded", (event) => {
  //updatePricesBasedOnCart();
});



// updateProgressBarPreview est maintenant un alias : updateProgressBarFull gère
// déjà le panier réel ET le total prédictif (panier + produit + accessoires cochés).
// Conservé pour les call sites existants (DOMContentLoaded, checkThisCard).
function updateProgressBarPreview() {
  updateProgressBarFull();
}

// Barre de progression à paliers de la FICHE PRODUIT (#mmProgressBarProduct,
// rendue par le Liquid de main-product). Calcule deux jauges : le panier réel
// (barre pleine) et le total prédictif panier + produit affiché + accessoires
// cochés (barre preview grisée), puis met à jour les icônes des steps
// (cadenas / check / badge remise) et des lignes "top". Appelée au
// DOMContentLoaded (via mm-main-product-helper.js), à chaque case accessoire
// cochée (checkThisCard) et après chaque re-render du panier.
function updateProgressBarFull() {
  const container = document.querySelector('#mmProgressBarProduct');
  if (!container) return;

  // ====== 1. Lectures de base ======
  // progressPrice = sous-total avant remises-récompense (cf. mmAPIRequest).
  const cart_value = parseInt(
    document.querySelector('.mm-dc-cta')?.dataset.progressPrice || 0
  );
  // dataset.PRICE (prix de la variante seule, rendu serveur, jamais réécrit)
  // et surtout PAS dataset.value : value = prix du bouton d'achat, réécrit par
  // updateCTAButtonPrice() en « variante + accessoires cochés » → les
  // accessoires seraient comptés DEUX fois (ici + options_value ci-dessous).
  // Bug corrigé 29/07/2026 : plaque cochée à -50% → prédictif 49,91 au lieu
  // de 44,93 → palier 49€ coché à tort sur la fiche produit.
  const product_value = parseInt(
    document.querySelector('#mmDataPriceElem')?.dataset.price || 0
  );

  // Variant IDs déjà au panier (pour ne pas double-compter)
  // Important : scoper aux vraies lignes panier (.mm-dc-product-main),
  // pas aux cross-sell (.mm-dc-cs-product) qui partagent l'attribut
  // data-cart-item-id mais ne sont PAS dans le panier.
  const cart_variant_ids = Array.from(
    document.querySelectorAll('.mm-drawer-cart-filter .mm-dc-product-main[data-cart-item-id]')
  ).map(el => el.dataset.cartItemId);

  const current_variant_id = document.querySelector('#mmSelectedProductId')?.value;
  const product_in_cart = current_variant_id && cart_variant_ids.includes(current_variant_id);

  // Accessoires cochés non encore au panier
  const checked_options = document.querySelectorAll('.mm-accessory-card input[type="checkbox"]:checked');
  let options_value = 0;
  checked_options.forEach(input => {
    if (cart_variant_ids.includes(input.value)) return;
    options_value += parseInt(input.dataset.displayedPrice || 0);
  });

  // Total prédictif = panier réel + ce qui sera ajouté si on clique Ajouter
  const predictive_value =
    cart_value + (product_in_cart ? 0 : product_value) + options_value;

  // Accessoire avec discount déjà au panier ?
  // Primaire : marqueur <data-accessory-in-cart value="true"> posé par
  // mm-cart-item.liquid quand le block translated_discount a accessory_discount=true.
  // Fallback : si l'admin n'a pas configuré ce flag (cas observé), on scanne
  // le libellé de remise affiché sur les lignes panier (ex: "ACCESSOIRE À -50%").
  const accessoryInCart =
    !!document.querySelector('.mm-drawer-cart-filter data-accessory-in-cart[value="true"]') ||
    Array.from(
      document.querySelectorAll(
        '.mm-drawer-cart-filter .mm-dc-product-main .mm-dc-product-price-promoted'
      )
    ).some(el => /accessoire/i.test(el.textContent));
  // Accessoire actif = déjà au panier OU un accessoire ÉLIGIBLE (type "Accessoires")
  // coché sur la page. Bug lumières (19/06) : un non-accessoire coché (lumières) ne
  // doit PAS "consommer" le créneau -50% → le palier reste "disponible" (badge, sans
  // cadenas) tant qu'aucun vrai accessoire n'est pris, et passe "coché" seulement
  // quand un accessoire éligible est sélectionné.
  const eligibleAccessoryChecked = Array.from(checked_options).some(input => {
    const card = input.closest('.mm-accessory-card');
    return card && card.dataset.type === 'Accessoires';
  });
  const accessoryActive = accessoryInCart || eligibleAccessoryChecked;

  // ====== 2. Récupération des steps ======
  const step_elems = container.querySelectorAll('.mm-dc-pb-step-elem');
  const step_values = Array.from(step_elems)
    .map(s => parseInt(s.dataset.price))
    .sort((a, b) => a - b);
  const step_count = step_values.length;

  let reached_real = 0;
  let reached_pred = 0;
  step_values.forEach(v => {
    if (cart_value >= v) reached_real++;
    if (predictive_value >= v) reached_pred++;
  });

  const computePercent = reached => {
    if (step_count === 0) return 100;
    return reached >= step_count
      ? 100
      : ((reached + 1) / (step_count + 1)) * 100;
  };

  // ====== 3. Largeurs des deux barres ======
  const inner_bar = container.querySelector('.mm-dc-free-item-progress--inner');
  if (inner_bar) inner_bar.style.width = computePercent(reached_real) + '%';

  const preview_bar = container.querySelector('.mm-dc-free-item-progress--inner-preview');
  if (preview_bar) preview_bar.style.width = computePercent(reached_pred) + '%';

  // ====== 3b. Toggle de mm-dc-pb-success sur le wrapper (panier réel) ======
  const wrapper = container.querySelector('.mm-dc-free-item-progress-wrapper');
  const max_step_value = parseInt(
    document.querySelector('#mmCartProgressBarValue')?.value || 0
  );
  if (wrapper && max_step_value > 0) {
    wrapper.classList.toggle('mm-dc-pb-success', cart_value >= max_step_value);
  }

  // ====== 4. SVG des steps (sous la barre) ======
  // Les SVG sont lus depuis des <template> exposés par le Liquid (snippets
  // mm-pb-bar-icon-lock, mm-pb-top-icon-*, mm-icon-check) — modifier le snippet
  // pour changer l'icône partout (rendu initial + swaps JS).
  const readTpl = (id) => document.getElementById(id)?.innerHTML || '';
  const stepLockSvg = readTpl('mmPbBarIconLock');
  const stepCheckSvg = readTpl('mmPbBarIconCheck');
  const discountBadgeHtml = '<span class="mm-pb-discount-available"></span>';

  step_elems.forEach(step => {
    const isDiscountStep = step.dataset.discountStep === 'true';
    const step_value = parseInt(step.dataset.price);
    const isReachedReal = cart_value >= step_value;
    const isReachedPred = predictive_value >= step_value;
    const previewOnly = isReachedPred && !isReachedReal;

    // preview-activated : uniquement quand seul le prédictif a dépassé
    if (!step.classList.contains('mm-dc-pb-step-elem-activated')) {
      step.classList.toggle('mm-dc-pb-step-elem-preview-activated', previewOnly);
    }

    const innerIndexes = step.querySelectorAll('.mm-dc-pb-step-elem-index');
    const innerIndex = innerIndexes[innerIndexes.length - 1];
    if (!innerIndex) return;

    innerIndex.classList.remove('mm-bg-black', 'mm-bg-grey');

    if (isDiscountStep && !accessoryActive && isReachedPred) {
      // Step discount sans accessoire (panier ni coché) ET seuil atteint (au
      // moins en prédictif) => badge ; bg gris si seulement preview.
      // 29/07/2026 : condition isReachedPred ajoutée — la Bxgy -50% exige
      // désormais un minimum d'achat (30€) côté Shopify : sous le seuil la
      // remise n'est pas disponible → cadenas (branche finale), plus de badge.
      innerIndex.classList.add(previewOnly ? 'mm-bg-grey' : 'mm-bg-black');
      innerIndex.innerHTML = discountBadgeHtml;
    } else if (isReachedReal) {
      innerIndex.classList.add('mm-bg-black');
      innerIndex.innerHTML = stepCheckSvg;
    } else if (isReachedPred) {
      innerIndex.classList.add('mm-bg-grey');
      innerIndex.innerHTML = stepCheckSvg;
    } else {
      innerIndex.innerHTML = stepLockSvg;
    }
  });

  // ====== 5. Mise à jour des icônes de la section Top ======
  // (suit le total prédictif — pas de variation grise sur les TOP icônes,
  // qui n'ont pas de fond coloré dans le design)
  const top_lines = container.querySelectorAll('.mm-product-progress-bar-top-line');
  top_lines.forEach(line => {
    const iconWrapper = line.querySelector('.mm-product-progress-bar-top-line-icon');
    if (!iconWrapper) return;

    if (!iconWrapper.dataset.initialHtml) {
      iconWrapper.dataset.initialHtml = iconWrapper.innerHTML;
    }

    const priceElem = iconWrapper.querySelector('.mm-product-progress-bar-top-line-price');
    if (!priceElem) return;
    const priceText = priceElem.textContent.replace(/[^\d,\.]/g, '').replace(',', '.');
    const stepPrice = Math.round(parseFloat(priceText) * 100);
    if (isNaN(stepPrice)) return;

    // Ligne discount : exposée par le Liquid via data-discount-step (fallback HTML initial)
    const isDiscountLine =
      line.dataset.discountStep === 'true' ||
      iconWrapper.dataset.initialHtml.includes('mm-pb-discount-available');
    const priceHtml = priceElem.outerHTML;
    const isReachedReal = cart_value >= stepPrice;
    const isReachedPred = predictive_value >= stepPrice;
    const previewOnly = isReachedPred && !isReachedReal;

    // Classes sur la ligne TOP : mm-active (réel) ou mm-preview-active (prédictif seul)
    line.classList.remove('mm-active', 'mm-preview-active');
    if (isReachedReal) {
      line.classList.add('mm-active');
    } else if (previewOnly) {
      line.classList.add('mm-preview-active');
    }

    const lockedSvg = readTpl('mmPbTopIconLock');
    const checkSvg = readTpl('mmPbTopIconCheck');
    const topDiscountBadge = '<div class="mm-pb-top-icon-wrap"><span class="mm-bg-black"><span class="mm-pb-discount-available"></span></span></div>';

    let iconHtml;
    if (isDiscountLine && !accessoryActive && isReachedPred) {
      // Ligne discount sans accessoire (panier ni coché) ET seuil atteint en
      // prédictif => badge (rond vide). 29/07/2026 : isReachedPred ajouté,
      // même règle que les steps de la barre (Bxgy -50% à minimum 30€) —
      // sous le seuil → cadenas via le else final.
      iconHtml = topDiscountBadge;
    } else if (isReachedPred) {
      // Atteint en prédictif (réel ou preview) => check, iso avec la barre
      iconHtml = checkSvg;
    } else {
      iconHtml = lockedSvg;
    }

    iconWrapper.innerHTML = iconHtml + priceHtml;
  });

  // Recalcule aussi les prix des cartes accessoires de la PDP à chaque mise à
  // jour de la frise (chargement, ajout/retrait au panier, coche). Avant,
  // updateCardPrices n'était appelé qu'au clic d'une case → la règle "accessoire
  // au panier = plein tarif" ne s'appliquait pas après un simple ajout au panier.
  // (updateCardPrices est défini dans mm-main-product-helper.js.)
  if (typeof updateCardPrices === 'function') updateCardPrices();
}